import {Selection as D3Selection} from 'd3';
import {Point} from './primitives';

export enum MealCategory {'breakfast' = 'breakfast', 'lunch' = 'lunch', 'dinner' = 'dinner', 'snack' = 'snack'}

export interface MealFile {
    [key: string]: any;
    category: MealCategory;
    name: string;
    ingredients: IngredientEntry[];
    percentages: {
        [index: string]: number
    };
}

export interface FileMapping {
    data: MealFile;
    fileName: string;
}

export interface IngredientEntry {
    food_name: string;
}

export interface MealComponentEntry {
    percentage: number;
}

export interface ChartData {
    [index: string]: {
        [index: string]: MealComponentEntry
    };
}

export interface DescriptionData {
    [index: string]: {
        ingredients: string[];
        prepSteps: string[];
        name: string;
        category: MealCategory;
        [index: string]: any;
    };
}

export interface CategoryViewMapping {
    group: D3Selection<any, any, any, any>;
    triangles: { [index: string]: D3Selection<any, any, any, any> };
    label: D3Selection<any, any, any, any> | null;
}

export interface CategoryViewMappingCollection {
    [index: string]: CategoryViewMapping;
}

export interface HelperLinesMapping {
    points: Point[];
    angle: number;
}

export interface InitChartData {
    files: FileMapping[];
    dueDate: string;
}
